<div class="date-time-picker-container">
    <mat-form-field class="date-picker-field" [appearance]="appearance">
        <mat-label>Date</mat-label>
        <input
            matInput
            [matDatepicker]="picker"
            [formControl]="dateControl"
            [placeholder]="placeholder"
            [min]="minDate"
            readonly>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <ngx-mat-timepicker-field 
        [format]="12" 
        [defaultTime]="timeControl.value || ''"
        [formControl]="timeControl" />
</div>
